<style lang="scss" scoped>
@include component(login-error) {
	width: 700px;
	background: white;
	border-radius: 8px;
	margin: auto;
	margin-top: 200px;
	padding: 40px;
	@include part(icon) {
		font-size: 70px;
		margin-right: 20px;
		color: #ff5b5b;
		@include option(good) {
			color: green;
		}
	}
	@include part(title) {
		margin-bottom: 5px;
	}
}
</style>

<template>
  <div v-if="loginError" class="login-error d-flex align-items-center">
    <i class="fe fe-alert-circle login-error__icon"></i>
    <div>
      <h1 class="login-error__title">Uh oh! Unauthorised</h1>
      <p class="mb-0">
        You are not authorized to access this app, please
        <a
          href="http://school.wonde.com"
        >return to wonde.</a>
      </p>
    </div>
  </div>
</template>

<script>
import Bugsnag from '@bugsnag/js';
import { onLogin } from "../../vue-apollo";
export default {
	data() {
		return {
			loginError: false,
			errorMap: {
				expired: "Expired token",
				malformed: "Signature verification failed",
				unknown: "unknown",
			},
		}
	},
	mounted() {
		this.$apollo
			.mutate({
				mutation: gql`
					mutation ExtractToken($token: String!) {
						ExtractToken(token: $token)
					}
				`,
				variables: {
					token: this.$route.query.token
				},
				update: async (store, data) => {
					await onLogin(this.$apollo.vm.$apolloProvider.clients.defaultClient, data.data.ExtractToken);
					
					try {
						const userOrg = await this.getUserOrg();
				
						if (userOrg.data.User.organisation_id && !userOrg.data.User.school_id) {
							this.$router.push({ name: "organisation.schools" });
						} else {
							this.$router.push({ name: "directory" });
						}
					} catch (e) {
						this.$router.push({ name: "directory" });
					}
				}
			})
			.catch(e => {
				Bugsnag.notify(e, (event) => {
					event.addMetadata("data", {
						mesage: e.message
					});
				});
				
				this.handleError(e);
			});
	},
	methods: {
		handleError(err) {
			this.loginError = false;
			let errorPages;
			
			try {
				errorPages = JSON.parse(this.$route.query.errorPages);
			} catch (e) {
				window.location.replace(errorPages["unknown"]);
				return;
			}

			for (const [key, val] of Object.entries(this.errorMap)) {
				if ((err.message.includes(key) || key === "unknown") && errorPages[val]) {
					window.location.replace(errorPages[val]);
					return;
				}
			}

			this.loginError = true;
		},

		async getUserOrg() {
			return  await this.$apollo.query({
				query: gql`
					{
						User {
							organisation_id
							school_id
						}
					}
				`,
				fetchPolicy: "network-only"
			});
		}
	}
};
</script>
